export default __webpack_public_path__ + "static/grey-black-desserto-dfb725616f9f417070cec2e82da53750.png";